import {Component} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {MatDialogActions, MatDialogClose, MatDialogContent} from '@angular/material/dialog';
import {UserPickerComponent} from '../../../shared/components/user-picker.component';
import {MatButton} from '@angular/material/button';



@Component({
    imports: [
        MatDialogContent,
        UserPickerComponent,
        MatDialogActions,
        MatButton,
        MatDialogClose
    ],
    template: `
        <div mat-dialog-content style="display: flex; flex-direction: column; align-items: center; gap: 10px">
            <span>
                Choose a sales manager
            </span>
            <app-user-picker placeholder="Sales manager" [displayWithEmail]="true"
                             [myControl]="control"></app-user-picker>
        </div>
        <div mat-dialog-actions style="display: flex; justify-content: space-between">
            <button mat-flat-button [mat-dialog-close]="false">Cancel</button>
            <button mat-flat-button color="primary" [mat-dialog-close]="control.value" [disabled]="control.invalid">
                Continue
            </button>
        </div>`
})
export class AssignSalesManagerDialogComponent {
    control = new UntypedFormControl(null);
    constructor() {
    }
}
